import React from 'react';
import { LargeBlockQuoteContentModel } from 'src/api/models/LargeBlockQuote';
import {
  LargeBlockQuoteAuthor,
  LargeBlockQuoteAuthorText,
  LargeBlockQuoteAvatar,
  LargeBlockQuoteContainer,
} from './LargeBlockQuote.styles';
import Heading from 'src/elements/typography/heading';
import { GatsbyImage } from 'gatsby-plugin-image';
import Paragraph from 'src/elements/typography/paragraph';

const LargeBlockQuote = ({
  quote,
  authorName,
  authorTitle,
  authorAvatar,
}: LargeBlockQuoteContentModel): JSX.Element => {
  const quotedText = quote.replace(/"/g, '').replace(/“/g, '').replace(/”/g, '');

  return (
    <LargeBlockQuoteContainer>
      <Heading
        text={`“${quotedText}”`}
        standardSize='2.125'
        sizeMd='1.25rem'
        sizeSm='1.125rem'
        weight={700}
      />
      <LargeBlockQuoteAuthor>
        <LargeBlockQuoteAvatar>
          <GatsbyImage
            image={authorAvatar.gatsbyImageData}
            alt={authorName}
          />
        </LargeBlockQuoteAvatar>
        <LargeBlockQuoteAuthorText>
          <Heading
            standardSize='1.5'
            text={authorName}
            weight={700}
          />
          <Paragraph
            standardSize='1.125'
            text={authorTitle}
            weight={300}
          />
        </LargeBlockQuoteAuthorText>
      </LargeBlockQuoteAuthor>
    </LargeBlockQuoteContainer>
  );
};

export default LargeBlockQuote;
